<section class="agsec1">
    <div class="container">
        <div class="row">
            <div class='col-lg-12'>
                <div class="carousel" [attr.id]="componentId">

                    <div #carouselContainer class="carousel-container" [ngStyle]="{'transform': carouselTransform}">

                        <!-- Solo mostramos las tarjetas visibles en el rango determinado -->
                        <div *ngFor="let item of gallery" class="carousel-cell" [ngClass]="(isDesktop)?'desk' : 'mob'">

                            <div class="caja-item" (click)='openModal(item.position)'>
                                <span class="market"
                                    *ngIf="item.position === currentIndex + cant - 1">
                                    {{ currentIndex + 1 }}/{{ gallery.length }}
                                </span>
                                <img [src]="item.path" onerror="this.src='./assets/img/default.png'">
                            </div>
                        </div>


                    </div>
                    <!-- Flechas de navegación solo se muestran si hay más tarjetas -->
                    <div class="arrows" *ngIf="gallery.length > cant">
                        <!-- Flecha izquierda -->
                        <button [ngClass]="{'locked': lockedLeft}" (click)="moveLeft()" [disabled]="lockedLeft">
                            <img class="arrow-carrousel" src="./assets/img/arrow-carrousel-left.svg" alt="Left Arrow">
                        </button>

                        <!-- Flecha derecha -->
                        <button [ngClass]="{'locked': lockedRight}" (click)="moveRight()" [disabled]="lockedRight">
                            <img class="arrow-carrousel" src="./assets/img/arrow-carrousel-right.svg" alt="Right Arrow">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>